// JsFromRoutes CacheKey 7a1afdc43e628923046a24c931fdfa95
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/my-account/calendar'),
}
